import { render, staticRenderFns } from "./TextBodyRegular.vue?vue&type=template&id=06b6c1f2&scoped=true"
import script from "./TextBodyRegular.vue?vue&type=script&lang=js"
export * from "./TextBodyRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6c1f2",
  null
  
)

export default component.exports